/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const createRoutineBodyStartLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const createRoutineBodyAnchorClockLocalRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const createRoutineBodyRotationCountExclusiveMin = 0;
export const createRoutineBodyRotationCountMax = 2147483647;

export const createRoutineBodySectionsItemStartWeekdayMax = 7;

export const createRoutineBodySectionsItemStartLocalMinuteMin = 0;
export const createRoutineBodySectionsItemStartLocalMinuteMax = 1439;

export const createRoutineBodySectionsItemEndWeekdayMax = 7;

export const createRoutineBodySectionsItemEndLocalMinuteMin = 0;
export const createRoutineBodySectionsItemEndLocalMinuteMax = 1439;

export const createRoutineBodySectionsItemFullWeekDefault = false;
export const createRoutineBodySectionsMax = 14;

export const createRoutineBodyParticipantsItemOrdinalMin = 0;
export const createRoutineBodyParticipantsItemOrdinalMax = 19;

export const createRoutineBodyParticipantsItemUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const createRoutineBodyParticipantsMax = 20;

export const createRoutineBodyEndedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const createRoutineBodyExpectedVersionExclusiveMin = 0;
export const createRoutineBodyExpectedVersionMax = 9007199254740991;

export const CreateRoutineBody = zod.object({
  name: zod.string(),
  startLocalDate: zod.iso.date().regex(createRoutineBodyStartLocalDateRegExp),
  anchorClockLocal: zod.string().regex(createRoutineBodyAnchorClockLocalRegExp),
  rotation: zod.object({
    unit: zod.enum(['day', 'week']),
    count: zod
      .int()
      .gt(createRoutineBodyRotationCountExclusiveMin)
      .max(createRoutineBodyRotationCountMax),
  }),
  sections: zod
    .array(
      zod.object({
        startWeekday: zod.int().min(1).max(createRoutineBodySectionsItemStartWeekdayMax),
        startLocalMinute: zod
          .int()
          .min(createRoutineBodySectionsItemStartLocalMinuteMin)
          .max(createRoutineBodySectionsItemStartLocalMinuteMax),
        endWeekday: zod.int().min(1).max(createRoutineBodySectionsItemEndWeekdayMax),
        endLocalMinute: zod
          .int()
          .min(createRoutineBodySectionsItemEndLocalMinuteMin)
          .max(createRoutineBodySectionsItemEndLocalMinuteMax),
        fullWeek: zod.boolean().default(createRoutineBodySectionsItemFullWeekDefault),
      }),
    )
    .min(1)
    .max(createRoutineBodySectionsMax),
  participants: zod
    .array(
      zod.object({
        ordinal: zod
          .int()
          .min(createRoutineBodyParticipantsItemOrdinalMin)
          .max(createRoutineBodyParticipantsItemOrdinalMax),
        userId: zod.uuid().regex(createRoutineBodyParticipantsItemUserIdRegExp),
      }),
    )
    .min(1)
    .max(createRoutineBodyParticipantsMax),
  endedAt: zod
    .union([
      zod.iso.datetime({ offset: true }).regex(createRoutineBodyEndedAtOneRegExp),
      zod.null(),
    ])
    .optional(),
  teamId: zod.unknown().optional(),
  scheduleId: zod.unknown().optional(),
  expectedVersion: zod
    .int()
    .gt(createRoutineBodyExpectedVersionExclusiveMin)
    .max(createRoutineBodyExpectedVersionMax),
});

export type CreateRoutineBody = zod.input<typeof CreateRoutineBody>;
export type CreateRoutineBodyOutput = zod.output<typeof CreateRoutineBody>;
